import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Badge, IconButton, Button } from "@material-ui/core";
import { Home, Search, Favorite, ArrowBack } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { GetDBNameFromParams } from "./URLParameters";
import logoImage from "./images/BandScannerLogo.PNG";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  greenButton: {
    fontFamily: 'Harvest',
    backgroundColor: "#00af50",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#008f40",
    },
  },
}));

function CapitalizeFirstLetter(str) {
  return str.replace(/_/g, " ").replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
}

function TopBar({ onOpenSearch, onFavouriteClick, isSearchActive, onClearSearch }) {
  const classes = useStyles();
  const [showFavourites, setShowFavourites] = useState(false);
  const subTitle = CapitalizeFirstLetter(GetDBNameFromParams());
  const [vidosLength, setVidosLength] = useState(0);

  useEffect(() => {
    const updateBadgeContent = () => {
      const vidos = localStorage.getItem("fav")
        ? JSON.parse(localStorage.getItem("fav")).length
        : 0;
      setVidosLength(vidos);
    };

    const handleFavVideosChanged = () => {
      console.log("Fav videos changed event received");
      updateBadgeContent();
    };

    updateBadgeContent();
    window.addEventListener("favVideosUpdated", handleFavVideosChanged);

    return () => {
      window.removeEventListener("favVideosUpdated", handleFavVideosChanged);
    };
  }, []);

  const handleFavouriteClick = () => {
    const vidos = localStorage.getItem("fav");
    //console.log("vidos", vidos);
    if (vidos === null) {
      alert(
        "No favourites, please add some videos to your favourites list using the heart icon."
      );
      return;
    }

    setShowFavourites(!showFavourites);
    if (onFavouriteClick) {
      onFavouriteClick(!showFavourites);
    }
  };

  return (
    <>
      <AppBar position="static" style={{ width: "100vw" }}>
        <Toolbar style={{ justifyContent: "space-between", flex: "1" }}>
          <Link to="/">
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={logoImage} alt="Logo" className="app_logo" style={{ height: "40px", marginRight: "10px" }} />
            <div className="app_title">BANDSCANNER</div>
          </div>
          </Link>
          <div style={{ display: "flex" }}>
            <IconButton color="inherit" onClick={handleFavouriteClick}>
              <Badge badgeContent={vidosLength} color="secondary" overlap="rectangular">
                <Favorite style={{ color: "black" }} />
              </Badge>
            </IconButton>
            <IconButton color="inherit" onClick={onOpenSearch}>
              <Search style={{ color: "black" }} />
            </IconButton>
            <IconButton
              color="inherit"
              onClick={() => window.location.reload(false)}
            >
              <Home style={{ color: "black" }} />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {isSearchActive ? (
        <div className="app_sub_title" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0' }}>
          <Button
            onClick={onClearSearch}
            startIcon={<ArrowBack />}
            variant="contained"
            className={classes.greenButton}
            style={{
              textTransform: 'none',
              fontSize: '16px',
              padding: '8px 16px'
            }}
          >
            Back to {subTitle} Events
          </Button>
        </div>
      ) : (
        <div className="app_sub_title">{subTitle}</div>
      )}
    </>
  );
}

export default TopBar;
